import { css } from 'lit';

export const customerPageStyles = css`
  .inline {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-2);
    margin-top: var(--space-4);
  }

  .inline input {
    flex: 1 1 var(--inline-field-min-width);
    width: auto;
  }
`;
